/**
 * Mensagens prontas ("/" na caixa de texto). A troca de {atendente} e
 * {cliente} acontece aqui, antes de enviar: a pessoa vê exatamente o texto
 * que vai sair e pode ajustar o valor do orçamento antes.
 */
export interface RespostaRapida {
  id: string;
  atalho: string;
  titulo: string;
  texto: string;
  ordem: number;
}

function primeiroNome(nome: string | null | undefined): string {
  return (nome ?? '').trim().split(/\s+/)[0] ?? '';
}

export function aplicarVariaveis(texto: string, dados: { atendente?: string | null; cliente?: string | null }): string {
  const atendente = primeiroNome(dados.atendente);
  const cliente = primeiroNome(dados.cliente);
  return texto
    .replace(/\{atendente\}/gi, atendente ? atendente.toUpperCase() : 'equipe')
    .replace(/\s*\{cliente\}/gi, cliente ? ` ${cliente}` : '');
}

function semAcento(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

/** Texto começando com "/" e sem espaço depois da palavra: está escolhendo. */
export function consultaDeAtalho(texto: string): string | null {
  const m = /^\/([^\s]*)$/u.exec(texto);
  return m ? semAcento(m[1] ?? '') : null;
}

export function filtrarRespostas(lista: RespostaRapida[], consulta: string): RespostaRapida[] {
  if (!consulta) return lista;
  return lista.filter((r) => r.atalho.startsWith(consulta) || semAcento(r.titulo).includes(consulta));
}
